import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Badge } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner, LiveModeBadge } from "../../components/ProposalGrounded";

// Submission packaging is workspace-scoped. This page lists workspaces and links
// into each workspace where packages, portal readiness, and evidence packs live.
// Submission itself is never automated — it stays a human action.
export function PaiSubmission() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => proposalApi.workspaces(orgId), [orgId]);
  const workspaces = state.data?.data.workspaces ?? [];

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Submission Center</h1>
          <p>Assemble packages and check portal readiness. Submission stays a human action.</p>
        </div>
        <LiveModeBadge demoMode={state.data?.demoMode ?? false} />
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      {state.loading && <LoadingState label="Loading workspaces…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {!state.loading && workspaces.length === 0 && (
        <EmptyState title="No workspaces" description="Create a workspace to assemble a submission package." />
      )}
      {workspaces.length > 0 && (
        <div className="ods-stack">
          {workspaces.map((w) => (
            <Card key={w.id}>
              <CardHeader
                title={w.title}
                action={
                  <Link to={`/studio/proposal-ai/workspace/${w.id}`}>
                    <Button size="sm">Open submission</Button>
                  </Link>
                }
              />
              <CardBody>
                <Badge tone="info">{w.status}</Badge>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
